// src/actions/preview.js
import {
    UPDATE_PREVIEW_DATA,
    RESET_PREVIEW_DATA,
    UPDATE_PREVIEW_MEDIA,
    UPDATE_PREVIEW_CONTENT,
    SET_PREVIEW_PLATFORM,

    SET_ENGAGEMENT_DATA,
    UPDATE_REACTIONS,
    ADD_COMMENT,
    DELETE_COMMENT,
    UPDATE_ANALYTICS,
    UPDATE_COMMENT_LIKES,
    SET_PLATFORM_DATA,
    TOGGLE_REACTION,
    UPDATE_IMPRESSIONS,
    ADD_SHARE,
    SET_POST_VISIBILITY,
    UPDATE_POST_STATS,
  } from '../constants/action-types/preview';
  
  export const setPreviewPlatform = (platform) => ({
    type: SET_PREVIEW_PLATFORM,
    payload: platform
  });

  export const updatePreviewData = (data) => ({
    type: UPDATE_PREVIEW_DATA,
    payload: data
  });
  
  export const resetPreviewData = () => ({
    type: RESET_PREVIEW_DATA
  });
  
  export const updatePreviewMedia = (media) => ({
    type: UPDATE_PREVIEW_MEDIA,
    payload: media
  });
  
  export const updatePreviewContent = (content) => ({
    type: UPDATE_PREVIEW_CONTENT,
    payload: content
  });

  export const setPlatformData = (platform, posts) => ({
    type: SET_PLATFORM_DATA,
    payload: {
      platform,
      posts
    }
  });
  
  export const setEngagementData = (data) => ({
    type: SET_ENGAGEMENT_DATA,
    payload: data
  });
  
  export const updateReactions = (postId, reaction, userId) => ({
    type: UPDATE_REACTIONS,
    payload: {
      postId,
      reaction,
      userId
    }
  });
  
  export const addComment = (comment) => ({
    type: ADD_COMMENT,
    payload: comment
  });
  
  export const deleteComment = (commentId) => ({
    type: DELETE_COMMENT,
    payload: commentId
  });
  
  export const updateCommentLikes = (commentId, userId) => ({
    type: UPDATE_COMMENT_LIKES,
    payload: {
      commentId,
      userId
    }
  });
  
  export const updateAnalytics = (platform, analytics) => ({
    type: UPDATE_ANALYTICS,
    payload: {
      platform,
      analytics
    }
  });
  
  export const updateImpressions = (platform, impressions) => ({
    type: UPDATE_IMPRESSIONS,
    payload: {
      platform,
      impressions
    }
  });
  
  export const addShare = (shareData) => ({
    type: ADD_SHARE,
    payload: shareData
  });
  
  export const setPostVisibility = (visibility) => ({
    type: SET_POST_VISIBILITY,
    payload: visibility
  });
  
  export const updatePostStats = (platform, postId, stats) => ({
    type: UPDATE_POST_STATS,
    payload: {
      platform,
      postId,
      stats
    }
  });
  
  // Async action creators with thunk
  // export const fetchPlatformData = (platform) => {
  //   return async (dispatch) => {
  //     try {
  //       // API call would go here
  //       const response = await api.getPlatformData(platform);
  //       dispatch(setPlatformData(platform, response.posts));
  //       dispatch(updateAnalytics(platform, response.analytics));
  //     } catch (error) {
  //       console.error('Error fetching platform data:', error);
  //     }
  //   };
  // };
  
  // export const toggleReaction = (postId, reaction) => {
  //   return async (dispatch, getState) => {
  //     const { currentUser } = getState();
  //     try {
  //       // API call would go here
  //       await api.toggleReaction(postId, reaction);
  //       dispatch(updateReactions(postId, reaction, currentUser.id));
        
  //       // Update analytics after reaction
  //       const { platform } = getState().social.currentPlatform;
  //       const response = await api.getUpdatedAnalytics(platform);
  //       dispatch(updateAnalytics(platform, response));
  //     } catch (error) {
  //       console.error('Error toggling reaction:', error);
  //     }
  //   };
  // };
  
  // export const submitComment = (postId, commentText) => {
  //   return async (dispatch, getState) => {
  //     const { currentUser } = getState();
  //     try {
  //       // API call would go here
  //       const comment = await api.submitComment(postId, {
  //         text: commentText,
  //         userId: currentUser.id,
  //         timestamp: new Date().toISOString()
  //       });
  //       dispatch(addComment(comment));
        
  //       // Update analytics after commenting
  //       const { platform } = getState().social.currentPlatform;
  //       const response = await api.getUpdatedAnalytics(platform);
  //       dispatch(updateAnalytics(platform, response));
  //     } catch (error) {
  //       console.error('Error submitting comment:', error);
  //     }
  //   };
  // };
  
  // export const sharePost = (postId, shareType) => {
  //   return async (dispatch, getState) => {
  //     const { currentUser } = getState();
  //     try {
  //       // API call would go here
  //       const shareData = await api.sharePost(postId, {
  //         userId: currentUser.id,
  //         shareType,
  //         timestamp: new Date().toISOString()
  //       });
  //       dispatch(addShare(shareData));
        
  //       // Update analytics after sharing
  //       const { platform } = getState().social.currentPlatform;
  //       const response = await api.getUpdatedAnalytics(platform);
  //       dispatch(updateAnalytics(platform, response));
  //     } catch (error) {
  //       console.error('Error sharing post:', error);
  //     }
  //   };
  // };